import React, { useEffect, useState, useReducer, useRef } from "react";
import axios from "axios";
import { ProductCustomizerState, CustomizerProduct, CustomizerImages } from "../types/ProductCustomizer";
import { getSkuObject } from "../utils/getSkuObject";
import isEmptyObject from '../utils/isEmptyObject';
import { productOptionToString } from "../utils/productOptionToString";

export const ProductCustomizerImages = ({ state, product, dispatch }: { state: ProductCustomizerState, product: CustomizerProduct, dispatch: Function }) => {
  const [skuObj, setSkuObj] = useState();
  const [imagesByOption, setImagesByOption] = useState();
  const [imageSrc, setImageSrc] = useState<string>();
  const [imageLoading, setImageLoading] = useState<boolean>(true);
  const loading: string = "https://cdn.shopify.com/s/files/1/0562/6442/5517/files/loading-taupe-lg.gif?v=1659630177";
  const [imageCover, setImageCover]=useState(true)
  async function getImagesByOption() {
    const { data } = await axios.post('https://cy30x3rr4j.execute-api.us-east-1.amazonaws.com/builder-provider-devel');
    setImagesByOption(data);
  }

  function setMainImage() {
    let imageMatch: string;
    if (state.variant.featured_image) {
      imageMatch = state.variant.featured_image.src;
    } else {
      imageMatch = product.featured_image;
    }

    if (imageMatch) {
      dispatch({ type: "updateImage", value: imageMatch, key: "main" });
    };
  }

  function setSecondaryImages() {
    if (skuObj) {
      let variantStepIdToStringMap = {};
     
      product.options?.forEach((opt) => {
        let val = opt.name === "Type" || opt.name === "Wig Type" ? "wig" : opt.name.toLowerCase();
        variantStepIdToStringMap[opt.id] = val;
      });

      let optionValuePairs = {};
 
      state.selectedOptions.forEach((opt, i) => {
        const step = state.steps[i];
        if (step.type === "variant" || step.type === "line_item") {
          optionValuePairs[step.id] = step.options[opt].id;
        }
      });

      state.selectedOptions.forEach((opt, i) => {
        const step = state.steps[i];
        const stepId = step.type === "variant" ? variantStepIdToStringMap[step.id] : step.id;

        if (stepId === "length" && skuObj && skuObj.Length!='30') {
          const match = imagesByOption?.options["ginger"][stepId][skuObj.Product][skuObj.Length];
          if (match) dispatch({ type: "updateImage", value: match, key: "length" });
        }

        if (stepId === "wig") {
          const match = imagesByOption?.options["ginger"][stepId][skuObj.Product][skuObj.Length][skuObj.Type];
          if (match) dispatch({ type: "updateImage", value: match, key: "wig" });
        }

        if (stepId === "Cut") {
          const val = optionValuePairs[stepId];
          const match = imagesByOption?.options["ginger"]["cut"][skuObj.Product][skuObj.Length][val.toUpperCase()];
          if (match) {
            dispatch({ type: "updateImage", value: match, key: "Cut" });
          } else {
            dispatch({ type: "updateImage", value: null, key: "Cut" });
          }
        }

        if (stepId === "Part_Style") {
          const val = optionValuePairs[stepId];
          //add the login for chole bean's collection displaying her images for park style
          let match=""
          if(state.variant.name.includes("No. 32")||state.variant.name.includes("No. 33")||state.variant.name.includes("No. 34")
          || state.variant.name.includes("No. 35")){
             match=state.images.main
          }
          else{
             match = imagesByOption?.options["ginger"]["part"][skuObj.Product][skuObj.Length][val.toUpperCase()];
          }
          if (match) dispatch({ type: "updateImage", value: match, key: "Part_Style" });
        }

        if (stepId === "Hair_Styling") {
          const val = optionValuePairs[stepId];
          const match = imagesByOption?.options["ginger"]["style"][skuObj.Product][skuObj.Length][val.toUpperCase()];
          if (match) dispatch({ type: "updateImage", value: match, key: "Hair_Styling" });
        }

        if (stepId === "Bang") {
          let match;
            if(optionValuePairs["Bang"] == "curtain"){
              match = imagesByOption?.options["ginger"]["cut"][skuObj.Product][skuObj.Length]["CURTAINBANG"];
            }
            else if (optionValuePairs["Bang"] == "fringe"){
              match = imagesByOption?.options["ginger"]["cut"][skuObj.Product][skuObj.Length]["FRINGEBANG"];
            }
            else if (optionValuePairs["Bang"] === "yes") {
            if (optionValuePairs["Cut"] === "bob") {
              match = imagesByOption?.options["ginger"]["cut"][skuObj.Product][skuObj.Length]["BOB BANG"];
            } else {
              match = imagesByOption?.options["ginger"]["cut"][skuObj.Product][skuObj.Length]["BANG"];
            }
          }
          if (match) {dispatch({ type: "updateImage", value: match, key: "Bang" });
          } else {
            dispatch({ type: "updateImage", value: null, key: "Bang" });
          }
        }
        if(stepId==="Prep"){
          const val = optionValuePairs[stepId];
          const match = imagesByOption?.options["ginger"]["hair_prep"][val.toUpperCase()];
          if (match) dispatch({ type: "updateImage", value: match, key: "Prep" });
        }
      });
    }

  }

  function updateToCurrentStepImage() {
    const step = state.steps[state.activeStep];
    let stepId: string;

    if (step.type === "variant") {
      let variantStepIdToStringMap = {};
      // console.log(product.options)
      product.options.forEach((opt) => {
        let val = opt.name === "Type" || opt.name === "Wig Type" ? "wig" : opt.name.toLowerCase();
        variantStepIdToStringMap[opt.id] = val;
      });
      stepId = variantStepIdToStringMap[state.steps[state.activeStep].id];
    } else if (step.type === "line_item") {
      stepId = step.id;
    }

    const match = state.images[stepId];
    if (match) {
      setImageSrc(match);
    } else {
      setImageSrc(state.images.main);
    }
  }

  useEffect(() => {
    getImagesByOption();
  }, []);

  useEffect(() => {
    if (!isEmptyObject(state.variant)) {
      setMainImage();
      if (state.variant.sku) {
        //if it is PMP service use STR-NTR-20 for images
        if(state.variant.sku.includes("PMPR")){
           let skuObj={
            Type: state.variant.sku.split("-")[0]+"-"+state.variant.sku.split("-")[1], 
            Product: 'STR', 
            Color: 'NTR',
            Length: '20'
           }
           setSkuObj(skuObj);
        }
        else{
        try{
        const skuObj = getSkuObject(state.variant);
        setSkuObj(skuObj);
        }
        catch{
          setSkuObj(null)
        }
        }
      }
    }
  }, [state.variant]);

  useEffect(() => {
    if (!isEmptyObject(state.variant)) {
      setSecondaryImages();
    }
  }, [imagesByOption]);

  useEffect(() => {
    setImageSrc(state.images.main);
  }, [state.images.main]);

  useEffect(() => {
    if (!isEmptyObject(state.variant)) {
      setSecondaryImages();
    }
  }, [state.selectedOptions]);

  useEffect(() => {
    if (!isEmptyObject(state.images)) {
      updateToCurrentStepImage();
    }

  }, [state.images]);

  useEffect(() => {
    if (!isEmptyObject(state.variant)) {
      updateToCurrentStepImage();
    }

  }, [state.activeStep]);

  function stepHasImage() {
    return state.steps[state.activeStep] && state.steps[state.activeStep].image;
  }

  return (
    <div className={`flex flex-col relative h-full md:h-screen justify-end ${ (state.steps.length > 0 && state.steps[state.activeStep].id === "intro")? "":"md:w-[50rem] md:m-auto"
  }`}>
      {stepHasImage()
        ? <div className="w-full h-full">
            <img
              src={state.steps[state.activeStep].image}
              className="w-full h-full object-cover object-center"
              alt={state.steps[state.activeStep].image_alt}
            />
          </div>
        :
        <>
          <div className={`${imageCover ? 'md:h-screen' : ''}`}>
            {imageLoading &&
              <div className="absolute w-full h-full top-0">
                <img src={loading} className="w-full h-full object-cover object-center" aria-hidden="true" />
              </div>
            }
     
            {imageSrc &&
            <div>
              <img
                src={imageSrc}
                alt={`${product.title} in ${state.variant.title}`}
                onLoad={() => setImageLoading(false)}
                className={`${imageCover ? 'md:absolute w-full h-full object-cover object-center' : 'w-full'}`}
              />
              </div>
            }
          </div>
          <div aria-label="Carousel pagination" className="absolute left-[0.5rem] bottom-[0.5rem] md:left-[2rem] md:bottom-[2rem] z-10 flex flex-col gap-[0.5rem]">
            {state.images.main &&
              <button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl bg-taupe-200/[.6] overflow-hidden" onClick={() => setImageSrc(state.images.main)}>
                <img src={state.images.main} alt="" className="" />
                <span className="sr-only">Main product</span>
              </button>
            }
            {state.images.length && skuObj && skuObj.Length!=`12`&& skuObj.Length!=`30` ?
              (<button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl bg-taupe-200/[.6] overflow-hidden" onClick={() => setImageSrc(state.images.length)}>
                <img src={state.images.length} alt="" className="" />
                <span className="sr-only">Length</span>
              </button>) :(<button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl bg-taupe-200/[.6] overflow-hidden" onClick={() => setImageSrc(state.images.main)}>
                <img src={state.images.main} alt="" className="" />
                <span className="sr-only">Length</span>
              </button>)
            }
            {state.images.wig &&
              <button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl overflow-hidden" onClick={() => setImageSrc(state.images.wig)}>
                <img src={state.images.wig} alt="" className="" />
                <span className="sr-only"></span>
              </button>
            }
            {state.images.Cut &&
              <button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl overflow-hidden" onClick={() => setImageSrc(state.images.Cut)}>
                <img src={state.images.Cut} alt="" className="" />
                <span className="sr-only"></span>
              </button>
            }
            {state.images.Bang &&
              <button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl overflow-hidden" onClick={() => setImageSrc(state.images.Bang)}>
                <img src={state.images.Bang} alt="" className="" />
                <span className="sr-only"></span>
              </button>
            }
            {state.images.Part_Style &&
              <button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl overflow-hidden" onClick={() => setImageSrc(state.images.Part_Style)}>
                <img src={state.images.Part_Style} alt="" className="" />
                <span className="sr-only"></span>
              </button>
            }
            {state.images.Hair_Styling &&
              <button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl overflow-hidden" onClick={() => setImageSrc(state.images.Hair_Styling)}>
                <img src={state.images.Hair_Styling} alt="" className="" />
                <span className="sr-only"></span>
              </button>
            }

             {state.images.Prep &&
              <button className="h-[2.5rem] w-[2.5rem] md:h-[4rem] md:w-[4rem] border border-taupe-600 rounded-xl overflow-hidden" onClick={() => setImageSrc(state.images.Prep)}>
                <img src={state.images.Prep} alt="" className="" />
                <span className="sr-only"></span>
              </button>
            }       
          </div>
        </>
      }
    </div>
  );
};
